import { render, staticRenderFns } from "./TutorialGame.vue?vue&type=template&id=1969d847&scoped=true&"
import script from "./TutorialGame.vue?vue&type=script&lang=js&"
export * from "./TutorialGame.vue?vue&type=script&lang=js&"
import style0 from "./TutorialGame.vue?vue&type=style&index=0&id=1969d847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969d847",
  null
  
)

export default component.exports